<template>
    <div class="tab-wrap">
      <search-item
        title="分类："
        :typeList="typeList"
        :defaultKey="defaultKey"
        @click="clickThird"
        :select="selected"
      ></search-item>
      <search-item
        :defaultKey="defaultKey"
        :status='true'
        title="板块："
        :secondList="secondList"
        @plateClick="clickBuy"
        :select="secondSelect"
        :selectParent="selectId"
      ></search-item>
        <!-- <ul class="type-wrap">
          <template v-for="v in typeList">
            <li class="type-item mouse-style" :title="v.name" :class="{'active-tab':activeId == v.id}" :key="v.id" @click.stop="choose(v)">{{v.name}}</li>
          </template>
        </ul> -->
   </div>
</template>
<script>
import SearchItem from './search-item'
import { getLcWeb } from '@/api/lc_web'
export default {
  data () {
    return {
      activeId: 0,
      typeList: [],
      secondList: [],
      parentId: '',
      defaultKey: {
        label: 'name',
        value: 'id'
      },
      selected: -1,
      secondSelect: -1
    }
  },
  components: {
    SearchItem
  },
  props: {
    selectId: {
      type: [String, Number]
    }
  },
  methods: {
    clickThird (data) {
      if (data !== 'all') {
        this.parentId = data.id
      } else {
        this.parentId = ''
      }
      this.$emit('choose', this.parentId)
      this.secondSelect = -1
    },
    clickBuy (data, idx) {
      this.secondSelect = idx
      this.parentId = data.id
      this.$emit('plateChoose', this.parentId)
    },
    async getTypes (val) {
      const res = await getLcWeb({
        name: 'lc.market.category.list',
        data: {
          parentId: val
        }
      })
      if (res.code === 0) {
        if (!this.status) {
          this.secondList = res.value ? res.value : []
        }
      }
    }
  },
  created () {
    this.selected = this.selectId ? this.selectId : this.selected
    if (this.selectId) {
      this.getTypes(this.selectId)
    }
  }
}
</script>
<style lang="scss" scoped>
.tab-wrap{
    width: 1200px;
    align-items:center;
    margin:48px auto;
}
.type-item{
    width:94px;
    height:32px;
    line-height:32px;
    text-align:center;
    display:inline-block;
    padding:0 5px;
    margin-right:20px;
    color: #5E5B5B;
    border: 1px solid #caddec;
    border-radius: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
}
.type-item:nth-child(1){
  margin-left:0;
}
.active-tab{
   background: #187FC3;
   color:#fff;
   border: 1px solid #187fc3;
}
</style>
